import { Roles } from "@shared/Roles";
import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { remult } from "remult";

interface PrivateRouteProps {
  children: ReactNode;
  role?: string | string[];
}

const PrivateRoute = ({ children, role }: PrivateRouteProps) => {

  const authenticate = remult.isAllowed(role ? role : Roles.AdminsAndManager);
  return !authenticate ? <Navigate to="/login" replace /> : children;
};

export default PrivateRoute;
